import { useContext } from "react";
import { RightDrawerContext } from "../context/RightDrawerContext";
import Sidebar from "../sidebar/Sidebar";
import { AppShell, Main } from "./MainLayout.style";
import { useSupportedScreenSize } from "./useSupportedScreenSize";

type MainLayoutType = {
  children: React.JSX.Element;
  onLogout: () => void;
  showSideBar?: boolean;
};

const MainLayout = ({
  children,
  onLogout,
  showSideBar = true,
}: MainLayoutType) => {
  const { open } = useContext(RightDrawerContext);
  useSupportedScreenSize();

  return (
    <Main open={open}>
      <AppShell>
        {showSideBar && <Sidebar onLogout={onLogout} />}
        {children}
      </AppShell>
    </Main>
  );
};

export default MainLayout;
